import React from 'react';
import { PropTypes } from 'prop-types';

import { Link } from 'react-scroll';

import MenuSectionsBarNavLinkWrapper from 'components/MenuSectionsBarNavLinkWrapper';
import MenuSectionsBarNavLink from 'components/MenuSectionsBarNavLink';
import MenuSectionsNavLinkLabel from 'components/MenuSectionsBarNavLinkLabel';

import { slugify } from 'helpers/slugify';
import { toTitleCase } from 'bento-ordering/base/utils/textUtils';

class MenuSectionBarNavItem extends React.Component {
  static propTypes = {
    menuSection: PropTypes.object,
    index: PropTypes.number,
    lastSectionItemIndex: PropTypes.number,
    activeMenuSectionName: PropTypes.string,
    handleSetActive: PropTypes.func,
    justifyContent: PropTypes.string,
    offset: PropTypes.number,
    hasBottomPadding: PropTypes.bool,
    hasTopPadding: PropTypes.bool,
    isInMoreSection: PropTypes.bool,
    isVisible: PropTypes.bool,
    onFocus: PropTypes.func
  };

  static defaultProps = {
    hasBottomPadding: true,
    hasTopPadding: true,
    isInMoreSection: false,
    isVisible: true
  };

  render() {
    const {
      menuSection,
      index,
      lastSectionItemIndex,
      activeMenuSectionName,
      handleSetActive,
      justifyContent,
      offset,
      hasBottomPadding,
      hasTopPadding,
      isInMoreSection,
      isVisible,
      onFocus
    } = this.props;

    const slugifiedMenuSectionName = slugify(menuSection.name);

    return (
      <MenuSectionsBarNavLinkWrapper
        id={`${slugify(menuSection.name)}-nav-item`}
        dataTestId={`${menuSection.id}-option`}
        justifyContent={justifyContent}
        isInMoreSection={isInMoreSection}
        isVisible={isVisible}
        onFocus={onFocus}
      >
        <Link
          key={`${menuSection.id}-bar-inner`}
          to={slugifiedMenuSectionName}
          spy={true}
          onSetActive={to => handleSetActive(to)}
          offset={offset}
          sx={{
            paddingBottom:
              activeMenuSectionName === slugifiedMenuSectionName &&
              isInMoreSection
                ? '8px'
                : 0,
            paddingRight: index === lastSectionItemIndex ? '6px' : ''
          }}
        >
          <MenuSectionsBarNavLink
            hasBottomPadding={hasBottomPadding}
            hasTopPadding={hasTopPadding}
            highlighted={slugifiedMenuSectionName === activeMenuSectionName}
          >
            <MenuSectionsNavLinkLabel
              highlighted={slugifiedMenuSectionName === activeMenuSectionName}
            >
              {toTitleCase(menuSection.name)}
            </MenuSectionsNavLinkLabel>
          </MenuSectionsBarNavLink>
        </Link>
      </MenuSectionsBarNavLinkWrapper>
    );
  }
}

export default MenuSectionBarNavItem;
